import { Accordion, AccordionSummary, AccordionDetails,  Typography, Box, Button, Stack, useMediaQuery, useTheme, Grow, Fade, Dialog, DialogContent, DialogContentText, DialogActions, DialogTitle } from '@mui/material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState } from 'react';

const Workflows = ({ workflows, isloading, userEmail, ticketDetails, orgId, prismToken, renderType, subDomain, ticketingSystem, agentDetails, queryText }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const [modalUrl, setModalUrl] = useState('');
  const handleOpenModal = (id, title) => {
    const url = encodeURI(
      `https://help.readyly.app/agent/ai-agent?workflowId=${id}&workflowName=${title}&ticketId=${ticketDetails?.id}`
    );
    setModalUrl(url);
    setOpen(true);
  };

  const handleProceed = () => {
    handleClose();
    window.open(modalUrl, '_blank');
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grow in={true} timeout={500}>
      <Accordion elevation={2} sx={{ borderRadius: 2, backgroundColor: '#f9f9fb' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#152938' }} />}>
          <Box display="flex" flexDirection="column">
            <Typography variant="h6" fontWeight="bold" color="#152938">Suggested Workflows</Typography>
            <Typography variant="body2" color="textSecondary" fontWeight={500}>{workflows.length} Workflows</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            {workflows.map((item, index) => (
              <Fade in={true} style={{ transitionDelay: `${index * 100}ms` }} key={index}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap={isMobile ? 'wrap' : 'nowrap'} sx={{ padding: 1.5, borderRadius: 2, backgroundColor: 'white', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)' }}>
                  <Box sx={{ width: isMobile ? '100%' : '75%', mb: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold" color="inherit">
                      {item?.meta?.title}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={1}>
                    <Button variant="contained" color="inherit" loadingPosition="end" startIcon={<AccountTreeOutlinedIcon/>} onClick={handleOpenModal} sx={{textTransform:"none"}} >
                      Execute
                    </Button>
                  </Box>
                </Box>
              </Fade>
            ))}
          </Stack>
        </AccordionDetails>
        <Dialog open={open} onClose={handleClose} >
          <DialogTitle>{"Open Workflow"}</DialogTitle>
          <DialogContent>
            <DialogContentText>Continue To The Workflow In A New Tab?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>No</Button>
            <Button onClick={handleProceed} autoFocus>yes</Button>
          </DialogActions>
        </Dialog>
      </Accordion>
    </Grow>
  )
}

export default Workflows